import {appSlice, cardFormSlice, utils} from 'payment-widget-core'
import {locales} from '@/locales/locales.js'
import {settings} from '@/config/settings.js'

import i18next, {t} from 'i18next'

i18next.init()

window.i18next = i18next

const i18nextUpdateResources = (locales) => {
  Object.entries(locales).forEach(([lang, data]) => {
    Object.entries(data).forEach(([namespace, data]) => {
      i18next.addResourceBundle(lang, namespace, structuredClone(data))
    })
  })
}

i18nextUpdateResources(locales)

let langCode = settings.env.APP_DEFAULT_LANGUAGE

if (appSlice.state.params.language) {
  const value = appSlice.state.params.language.toLowerCase()
  if (value in locales) {
    langCode = value
  }
}

if (langCode && langCode in locales) {
  i18next.changeLanguage(langCode)
} else {
  i18next.changeLanguage(Object.keys(locales)[0])
}

/*
 * This widget only ever runs the card scenario, so the store is a fixed pair of
 * slices rather than the switchable set the multi-method widget needs.
 * payment-widget-core's cache helpers walk `window.store` by key, which is why
 * it has to live on `window`.
 */
const store = {
  appSlice,
  cardFormSlice,
}

window.store = store

appSlice.actions.setSettings({
  ...settings,
  activeSlice: 'card',
})

appSlice.actions.restoreCache(store)

/**
 * Drops everything we know about this invoice and starts the flow over from
 * /form/init. Used by "Повторить оплату" on the failed status screen: the
 * failed state is persisted in localStorage, so a plain reload would restore
 * it instead of showing the form again.
 */
export function retryPayment() {
  const {invoice_id} = appSlice.state.params
  if (invoice_id) {
    try {
      localStorage.removeItem(invoice_id)
    } catch {
      // storage unavailable — the reload below still resets the in-memory state
    }
  }

  const url = new URL(window.location.href)
  url.pathname = '/'
  window.location.replace(url.toString())
}

export {store, utils}
export {t, i18next, i18nextUpdateResources}
